<form (ngSubmit)="save()">
  <div class="asetuspino">
    <div class="pohjavalitsimet">
      <mat-button-toggle-group class="segmentti" [value]="valittuPohja" (change)="valittuPohja = $event.value" [hideSingleSelectionIndicator]="true">
        <mat-button-toggle value="lasku">{{ 'laskuasetukset.pohja-lasku' | translate | async }}</mat-button-toggle>
        <mat-button-toggle value="muistutus">{{ 'laskuasetukset.pohja-maksumuistutus' | translate | async }}</mat-button-toggle>
        <mat-button-toggle value="hyvitys">{{ 'laskuasetukset.pohja-hyvityslasku' | translate | async }}</mat-button-toggle>
      </mat-button-toggle-group>
      <mat-button-toggle-group class="segmentti" [value]="valittuKieliIndeksi" (change)="valitseKieli($event.value)" [hideSingleSelectionIndicator]="true">
        @for (asetus of lomake.spostiasetukset; track asetus; let i = $index) {
          <mat-button-toggle [value]="i">{{ otsikko(i) }}</mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>

    <div>
      @for (asetus of lomake.spostiasetukset; track asetus; let i = $index) {
        @if (i === valittuKieliIndeksi) {
          <div>
            @if (valittuPohja === 'lasku') {
              <mat-form-field>
                <mat-label>{{ 'laskuasetukset.aihe' | translate | async }}</mat-label>
                <input #aiheKentta type="text" [formField]="asetus.aihe" matInput />
                <mat-error>{{ fieldErrors().aihe }}</mat-error>
              </mat-form-field>
              <div class="pohjan-muuttujat">
                @for (muuttuja of pohjanMuuttujat; track muuttuja.merkinta) {
                  <button type="button" (mousedown)="$event.preventDefault()" (click)="lisaaMuuttuja(aiheKentta, 'aihe', muuttuja.merkinta)">
                    <mat-icon>add</mat-icon>
                    {{ muuttuja.nimi }}
                  </button>
                }
              </div>
              <mat-form-field>
                <mat-label>{{ 'laskuasetukset.otsikko' | translate | async }}</mat-label>
                <input type="text" [formField]="asetus.otsikko" matInput />
                <mat-error>{{ fieldErrors().otsikko }}</mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'laskuasetukset.teksti' | translate | async }}</mat-label>
                <textarea rows="6" #tekstiKentta [formField]="asetus.teksti" matInput cdkTextareaAutosize></textarea>
                <mat-error>{{ fieldErrors().teksti }}</mat-error>
              </mat-form-field>
              <div class="pohjan-muuttujat">
                @for (muuttuja of pohjanMuuttujat; track muuttuja.merkinta) {
                  <button type="button" (mousedown)="$event.preventDefault()" (click)="lisaaMuuttuja(tekstiKentta, 'teksti', muuttuja.merkinta)">
                    <mat-icon>add</mat-icon>
                    {{ muuttuja.nimi }}
                  </button>
                }
              </div>
            } @else if (valittuPohja === 'muistutus') {
              <mat-form-field>
                <mat-label>{{ 'laskuasetukset.aihe' | translate | async }}</mat-label>
                <input #aiheKentta type="text" [formField]="asetus.maihe" matInput />
                <mat-error>{{ fieldErrors().maihe }}</mat-error>
              </mat-form-field>
              <div class="pohjan-muuttujat">
                @for (muuttuja of pohjanMuuttujat; track muuttuja.merkinta) {
                  <button type="button" (mousedown)="$event.preventDefault()" (click)="lisaaMuuttuja(aiheKentta, 'maihe', muuttuja.merkinta)">
                    <mat-icon>add</mat-icon>
                    {{ muuttuja.nimi }}
                  </button>
                }
              </div>
              <mat-form-field>
                <mat-label>{{ 'laskuasetukset.otsikko' | translate | async }}</mat-label>
                <input type="text" [formField]="asetus.motsikko" matInput />
                <mat-error>{{ fieldErrors().motsikko }}</mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'laskuasetukset.teksti' | translate | async }}</mat-label>
                <textarea rows="6" #tekstiKentta [formField]="asetus.mteksti" matInput cdkTextareaAutosize></textarea>
                <mat-error>{{ fieldErrors().mteksti }}</mat-error>
              </mat-form-field>
              <div class="pohjan-muuttujat">
                @for (muuttuja of pohjanMuuttujat; track muuttuja.merkinta) {
                  <button type="button" (mousedown)="$event.preventDefault()" (click)="lisaaMuuttuja(tekstiKentta, 'mteksti', muuttuja.merkinta)">
                    <mat-icon>add</mat-icon>
                    {{ muuttuja.nimi }}
                  </button>
                }
              </div>
            } @else {
              <mat-form-field>
                <mat-label>{{ 'laskuasetukset.aihe' | translate | async }}</mat-label>
                <input #aiheKentta type="text" [formField]="asetus.haihe" matInput />
                <mat-error>{{ fieldErrors().haihe }}</mat-error>
              </mat-form-field>
              <div class="pohjan-muuttujat">
                @for (muuttuja of pohjanMuuttujat; track muuttuja.merkinta) {
                  <button type="button" (mousedown)="$event.preventDefault()" (click)="lisaaMuuttuja(aiheKentta, 'haihe', muuttuja.merkinta)">
                    <mat-icon>add</mat-icon>
                    {{ muuttuja.nimi }}
                  </button>
                }
              </div>
              <mat-form-field>
                <mat-label>{{ 'laskuasetukset.otsikko' | translate | async }}</mat-label>
                <input type="text" [formField]="asetus.hotsikko" matInput />
                <mat-error>{{ fieldErrors().hotsikko }}</mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'laskuasetukset.teksti' | translate | async }}</mat-label>
                <textarea rows="6" #tekstiKentta [formField]="asetus.hteksti" matInput cdkTextareaAutosize></textarea>
                <mat-error>{{ fieldErrors().hteksti }}</mat-error>
              </mat-form-field>
              <div class="pohjan-muuttujat">
                @for (muuttuja of pohjanMuuttujat; track muuttuja.merkinta) {
                  <button type="button" (mousedown)="$event.preventDefault()" (click)="lisaaMuuttuja(tekstiKentta, 'hteksti', muuttuja.merkinta)">
                    <mat-icon>add</mat-icon>
                    {{ muuttuja.nimi }}
                  </button>
                }
              </div>
            }
          </div>
        }
      }
    </div>

    <div class="asetusvihje">{{ 'laskuasetukset.pohjien-muuttujat' | translate | async }}</div>
  </div>

  <h3>{{ 'laskuasetukset.yleiset' | translate | async }}</h3>
  <div class="asetusrypas">
    <mat-form-field>
      <mat-label>{{ 'laskuasetukset.slogan' | translate | async }}</mat-label>
      <input type="text" [formField]="lomake.slogan" matInput />
      <mat-hint>{{ 'laskuasetukset.slogan-hint' | translate | async }}</mat-hint>
      <mat-error>{{ fieldErrors().slogan }}</mat-error>
    </mat-form-field>
  </div>

  <div class="asetusnappulat">
    <button class="primarybutton" mat-button (click)="save()" type="button">{{ 'yleiset.tallenna' | translate | async }}</button>
  </div>
</form>
